import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class IsoMapGraph extends AbstractScatterVisualization {}
